import React from 'react';
import Header from "./Components/Header/Header";
import Main from "./Components/Main/Main";
import Footer from "./Components/Footer/Footer";
import './App.css';

// BEGIN all wallet info
import '@rainbow-me/rainbowkit/styles.css';
import { getDefaultWallets, RainbowKitProvider, midnightTheme } from '@rainbow-me/rainbowkit';
import { Chain, configureChains, createClient, WagmiConfig } from 'wagmi';
import { chain } from 'wagmi';
//import { mainnet, polygon, optimism, arbitrum } from 'wagmi/chains';
import { alchemyProvider } from 'wagmi/providers/alchemy';
import { publicProvider } from 'wagmi/providers/public';
//import { jsonRpcProvider } from 'wagmi/providers/jsonRpc';

// ADD POM chain as custom chain
export const pom: Chain = {
  id: 18159,
  name: 'Proof of Memes',
  network: 'pom',
  iconUrl: 'https://memescan.io/images/POM_logo_footer-3eec43e7c67b8a0609a38e5acabd1aa4.png',
  iconBackground: '#fff',
  nativeCurrency: {
    decimals: 18,
    name: 'POM',
    symbol: 'POM',
  },
  rpcUrls: {
    default: {
      http: ['https://mainnet-rpc.memescan.io/'],
    },
  },
  blockExplorers: {
    default: { name: 'MemeScan', url: 'http://memescan.io' },
    etherscan: { name: 'MemeScan', url: 'http://memescan2.io' },
  },
  testnet: false,
};

const { chains, provider } = configureChains(
  //[pom, mainnet, polygon ],
  [pom],[
    alchemyProvider({ apiKey: 'och0o8DF48y11Elp-MMGYp8gyzo4v5lq' }),
    publicProvider()
  ]
);

const { connectors } = getDefaultWallets({
  appName: 'MemeShib NFT Gallery',
  chains
});

const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider
})
// END all wallet info


function App() {

  return (
    <div className="App">
    <WagmiConfig client={wagmiClient}>
      <RainbowKitProvider  coolMode theme={midnightTheme()} chains={chains}>
 
        <Header title="MemeShib NFT Viewer" />

        <Main message="My content" />
      
        <Footer note="Footer Note" />
 
      </RainbowKitProvider>
    </WagmiConfig>
    </div>
  );
}

export default App;
